import { ProductVariant } from '@zonofi/zono-money-store';
import { PromotionTag } from '../../components';

interface PromotionsListProps {
  product: ProductVariant;
}

export const PromotionsList: React.FC<PromotionsListProps> = ({ product }) => {
  if (!product?.promotions?.length) return null;

  return (
    <div className="cart-promotion-view">
      {product.promotions.map((promotion) => (
        <PromotionTag
          key={`${product.id}-${promotion.promotionType}`}
          promotionType={promotion.promotionType}
          promotion={promotion?.promotion}
          minQtyASC={promotion?.minQtyASC}
          freeQtyASC={promotion?.freeQtyASC}
        />
      ))}
    </div>
  );
};
